import React, { useEffect, useState } from 'react';
import { useFutureOrderStore } from '../../../../components/Stores/FutureOrdersStore';
import { useAccountStore } from '../../../../components/Stores/accountStore';
import { DashBoardDonutCard, IDashboardDonutChartDataSet } from '../../../../components/UI-Elements/DashBoardDonutCard';
import { materialExposureDictionary } from '../../FutureOrders';
import { FutureOrdersSummeryBarChart } from './FutureOrdersSummeryGraphsCharts/FutureOrdersSummeryBarChart';
import { FutureOrdersSummeryGraphsSkeleton } from './FutureOrdersSummeryGraphsCharts/FutureOrdersSummeryGraphsSkeleton';
import { aggregateFutureOrdersToMaterialsDic } from '../Utils';
import { FutureOrdersSummaryLegend } from './FutureOrdersSummeryGraphsCharts/FutureOrdersSummaryLegend';
import { IFutureOrder } from '../../../../sp-types/FutureOrderType';
import { useMaterialsStore } from '@components/Stores/MaterialsStore';
import { getCurrentMonthYear, MonthYear } from '../../../../utils/MonthYear/monthYear';
import { useCurrencyRates } from '@hooks/useCurrencyRates';

interface Props {
  componentDataState: 'loading' | 'missing' | 'fetched';
  futureOrders: IFutureOrder[];
  currentMaterialId?: string;
}

export const FutureOrdersSummeryGraphs: React.FC<Props> = ({ componentDataState, futureOrders, currentMaterialId }) => {
  const { isFutureOrdersLoading } = useFutureOrderStore();
  const { materialColorDictionary: colorsMap } = useAccountStore();
  const { materialsMap } = useMaterialsStore();
  const { pricesMap } = useCurrencyRates();
  const [futureOrdersAsMaterial, setFutureOrdersAsMaterialDictionary] = useState<
    Record<string, materialExposureDictionary>
  >({});

  useEffect(() => {
    futureOrders?.length &&
      setFutureOrdersAsMaterialDictionary(
        aggregateFutureOrdersToMaterialsDic(
          futureOrders,
          currentMaterialId && currentMaterialId !== 'general' ? currentMaterialId : undefined,
          pricesMap,
        ),
      );
  }, [futureOrders, currentMaterialId]);

  const getDonutData = (
    orders: Record<string, { totalValue: number; exposureCalendar: Record<string, number> }>,
    valueByCurrentMonth?: MonthYear,
  ): IDashboardDonutChartDataSet[] =>
    Object.entries(orders).map(([materialId, item]): IDashboardDonutChartDataSet => {
      // const value = valueByCurrentMonth
      //   ? item.exposureCalendar[`${valueByCurrentMonth.year}${valueByCurrentMonth.month}`] || 0
      //   : item.totalValue;
      const value = item.totalValue;
      return {
        ratio: 0,
        fieldName: materialId,
        value,
        color: colorsMap[materialId],
      };
    });

  return isFutureOrdersLoading ? (
    <FutureOrdersSummeryGraphsSkeleton />
  ) : (
    <>
      <div className="bg-white  shadow-sm  p-[1.5rem]  ">
        {componentDataState === 'loading' && <FutureOrdersSummeryGraphsSkeleton />}
        {(componentDataState === 'fetched' || componentDataState === 'missing') && (
          <div className="flex justify-between space-x-4 max-h-[15rem]">
            <div>
              <h5>Summary</h5>
              <div className="max-w-[8.75rem]">
                <DashBoardDonutCard
                  secondaryTitle="Net value"
                  dataSet={getDonutData(futureOrdersAsMaterial, getCurrentMonthYear())}
                />
              </div>
            </div>
            <div className="flex my-auto min-w-60 overflow-y-scroll max-h-[12rem]  ">
              <FutureOrdersSummaryLegend
                materialsDataAsDictionary={futureOrdersAsMaterial}
                itemNames={materialsMap}
                colorsMap={colorsMap}
              />
            </div>
            <div className="flex flex-1 ">
              <FutureOrdersSummeryBarChart
                materialsDataAsDictionary={futureOrdersAsMaterial}
                itemNames={materialsMap}
                colorsMap={colorsMap}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
